import { render, staticRenderFns } from "./Resistance.vue?vue&type=template&id=f365f278&"
import script from "./Resistance.vue?vue&type=script&lang=js&"
export * from "./Resistance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports